import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { NgClass} from "@angular/common";
import {AssetStateService} from "../asset.state.service";
import {Subscription} from "rxjs";
import {SafePipe} from "../../common/pipes/safe.pipe";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {FullHeighDirective} from "../../common/full-heigh.directive";


@Component({
  selector: 'app-pdf-viewer',
    imports: [
        NgClass,
        SafePipe,
        MatIcon,
        MatIconButton,
        FullHeighDirective
    ],
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss'
})
export class PdfViewerComponent implements OnInit, OnDestroy{
    displayPdf: boolean = false;
    pdfSubscription: Subscription | undefined;
    pdfUrl: string | null = null;

    constructor(private assetStateService: AssetStateService) { }
    @HostListener('document:keydown.escape', ['$event'])
    onEsc(ev: KeyboardEvent) {
        this.close();
    }
    ngOnInit() {
        this.pdfSubscription = this.assetStateService.pdfSource$.subscribe(pdfUrl => {
            this.pdfUrl = pdfUrl;
            this.displayPdf = true;
        })
    }
    close(): void {
        this.pdfUrl = null;
        this.displayPdf = false;

    }
    ngOnDestroy() {
        if (this.pdfSubscription) {
            this.pdfSubscription.unsubscribe();
        }
    }
}
